const tracks = {
  BB: {
    LOGGED_IN: 'Logged in',
    CLEANED_EXISTING_TRANSACTIONS: 'Cleaned existing transactions',
    REGISTERED_TRANSFERS: 'Registered transfers',
    VALIDATED_TRANSFERS: 'Validated transfers',
    PUT_QR_CODE: 'Entered qr code',
    ERROR_QR_CODE: 'Error qr code',
    SENDED_TRANSFERS: 'Sended transfers'
  },
  CAIXA: {
    LOGGED_IN: 'Logged in',
    CLEANED_EXISTING_TRANSACTIONS: 'Cleaned existing transactions',
    REGISTERED_TRANSFERS: 'Registered transfers',
    FILLED_BATCH_NAME: 'Filled batch name',
    VERIFIED_STATUS_AND_VALUE: 'Verified status and value',
    CONFIRMED: 'Confirmed',
    AUTHORIZED: 'Authorized',
    SYNCED: 'Synced'
  },
  INTER: {
    LOGGED_IN: 'Logged in',
    CONFIRMED_TRANSACTION: 'Confirmed transaction',
    CONFIRMED_SMS_CODE: 'Confirmed SMS code'
  },
  ITAU: {
    LOGGED_IN: 'Logged in',
    AUTHORIZING_TRANSFERS: 'Authorizing transfers',
    AUTHORIZED_TRANSFERS: 'Authorized transfers'
  },
  ABC_BRASIL: {
    LOGGED_IN: 'Logged in',
    ACCESSED_TRANSFERS_PAGE: 'Accessed transfers page',
    ACCESSED_RECEIPTS_PAGE: 'Accessed receipts page',
    FILLED_RECEIPTS_FILTER: 'Filled receipts filter',
    ACCESSED_ACCOUNT_PAGE: 'Accessed account page',
    FILLED_STATEMENT_FILTER: 'Filled statement filter',
    ACCESSED_STATEMENT_PAGE: 'Accessed statement page'
  }
};

module.exports = tracks;
